import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { RecordatorioService } from '../../../../services/recordatorio.service';
import headersRecordatorio from '../../../../pages/dataHeaders/headersRecordatorio.json'
//import { Socket } from 'ngx-socket-io';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  showNotificationServer:boolean=false
  notificacionServer:string=""
  showMenu=false;
  isOpenMenu: boolean = false
  showBoxRecordatorio: boolean = false
  nombreUsuario:string=""
  listMenu:any[]=[]
  listRecordatorio:any[]=[]
  headersRecordatorio:any[]=[]
  constructor(
    private recordatorioService:RecordatorioService,
    private router: Router,
   // private socket: Socket
    ) { 
     /* this.socket.on('connect', () => {
        console.log('Conectado a servidor socket')
      });*/

      this.headersRecordatorio=headersRecordatorio
      /*this.socket.on('alerta-acuerdo-nuevo', (arg) => {
        console.log(arg);
        this.notificacionServer=arg
        this.showNotificationServer=true
      });*/
    }

  ngOnInit() {
    this.router.events.subscribe((val:any) => {
      
      if (val instanceof NavigationEnd) {
        if(val.url=="/login"){
          this.showMenu=false;
        }else if(val.url.indexOf("/gestion-cliente-libre")>-1){
          this.showMenu=false;
        }else{
          this.getRecordatorios()
          this.nombreUsuario=sessionStorage.getItem("nombre")
          if(sessionStorage.getItem("perfil")=="Asesor"){
            this.listMenu=[
              {
                text:"Negociacion",
                url:"lista-clientes-negociacion"
              },
              {
                text:"Salir",
                url:"login"
              }
            ]
          }

          if(sessionStorage.getItem("perfil")=="Analista"){
            this.listMenu=[
              {
                text:"Aprobaciones",
                url:"aprobaciones"
              },
              {
                text:"Negociacion",
                url:"lista-clientes-negociacion"
              },
              {
                text:"Data - Info",
                url:"reportes"
              },
              {
                text:"Salir",
                url:"login"
              }
            ]
          }

          if(sessionStorage.getItem("perfil")=="Operaciones"){
            this.listMenu=[
              {
                text:"Aprobaciones",
                url:"aprobaciones"
              },
              {
                text:"Acuerdos",
                url:"acuerdos"
              },
              {
                text:"OP-Extinguidas",
                url:"op-extinguidas"
              },
              {
                text:"Negociacion",
                url:"lista-clientes-negociacion"
              },
              {
                text:"Carga de Datos",
                url:"carga-info"
              },
              {
                text:"Data - Info",
                url:"reportes"
              },
              {
                text:"Usuarios",
                url:"usuarios"
              },
              {
                text:"Salir",
                url:"login"
              }
            ]
          }
          this.showMenu=true
          //this.showMenuAdmin()          
        }
      }
    });
  }

  getRecordatorios(){
    this.recordatorioService.getRecordatorios("").subscribe((data:any)=>{
      //console.log(data)
      this.listRecordatorio=data.recordatorio.docs
    })
  }

  toogleMenu() {
    if (!this.isOpenMenu) {
      this.isOpenMenu = true
    } else {
      this.isOpenMenu = false
    }
  }

  closeModal(e:any=""){
    this.showBoxRecordatorio=false
  }

}
